import * as Yup from 'yup';

const schema = Yup.object().shape({
  nome: Yup.string().required('Nome obrigatório'),
  email: Yup.string().email().required('Valor requerido'),
  password: Yup.string(),
  confirmacao_senha: Yup.string().oneOf(
    [Yup.ref('password'), null],
    'Senhas não conferem'
  ),
  cpf_cnpj: Yup.string().required('Valor requerido'),
  uf_rg_id: Yup.string().required('Valor requerido'),
  rg: Yup.string().required('Valor requerido'),
  logradouro:Yup.string().required('Valor requerido'),
  bairro:Yup.string().required('Valor requerido'),
  cep:Yup.string().required('Valor requerido'),
  cidade:Yup.string().required('Valor requerido'),
  uf_endereco_id:Yup.string().required('Valor requerido'),
  telefone: Yup.string().required('Valor requerido'),
  numero_whatsapp: Yup.string().required('Valor requerido'),
  formacao: Yup.string().required('Valor requerido'),
  anexo_cpf_cnpj: Yup.string(),
  anexo_rg: Yup.string(),
  anexo_endereco: Yup.string(),
  anexo_formacao: Yup.string()
});

export default schema;
